// extracted by mini-css-extract-plugin
module.exports = {"buttons":"WindowСontrolButtons_buttons_2IArb","green":"WindowСontrolButtons_green_AhG9q","purple":"WindowСontrolButtons_purple_1W4jj","red":"WindowСontrolButtons_red_2N3UQ"};